const prepareNextAuthErrorMessage = (errorMessage: string): string => {
  return errorMessage.replace("Error: ", "");
};

export default prepareNextAuthErrorMessage;
